<template>
  <div class="admin_sidebar">
    <el-menu :default-active="$route.path" class="el-menu-vertical-demo menu" @open="handleOpen" @close="handleClose" :router="true">
      <!-- <el-menu-item index="/admin/tasks">
        <i class="el-icon-location"></i>
        <span>任务中心</span>
      </el-menu-item> -->
      <!-- <router-link :to="{name:'tasks'}" tag="el-menu-item" active-class="is-active" index="1">
        <i class="el-icon-location"></i>
        <span>任务中心</span>
      </router-link>-->
      <el-menu-item index="/admin/competition-center" :class="activeClass" v-if="$store.getters.permissions.indexOf('admin_course_manage')>-1">
        <!-- <i class="el-icon-menu"></i> -->
        <span>创作中心</span>
      </el-menu-item>
      <el-menu-item index="/admin/user" v-if="$store.getters.permissions.indexOf('admin_user')>-1">
        <!-- <i class="el-icon-menu"></i> -->
        <span>用户管理</span>
      </el-menu-item>
      <el-menu-item index="/admin/roles" v-if="$store.getters.permissions.indexOf('admin_system')>-1">
        <!-- <i class="el-icon-menu"></i> -->
        <span>系统管理</span>
      </el-menu-item>
      <el-menu-item index="/admin/classroom" :class="classroomClass" v-if="$store.getters.permissions.indexOf('admin_classroom')>-1">
        <span>专题管理</span>
      </el-menu-item>
      <!-- <el-menu-item index="3">
        <i class="el-icon-document"></i>
        <span slot="title">订单</span>
      </el-menu-item>
      <el-menu-item index="4">
        <i class="el-icon-setting"></i>
        <span slot="title">财务</span>
      </el-menu-item>
      <el-menu-item index="5">
        <i class="el-icon-setting"></i>
        <span slot="title">邀请</span>
      </el-menu-item>-->
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 0,
      activeClass: "",
      classroomClass: ""
    };
  },
  // mounted() {
  //   this.pathLight();
  //   this.clssroomActive();
  // },
  methods: {
    handleOpen(key, keyPath) {
    },
    handleClose(key, keyPath) {
    },
    getCurrentMenu() {
      // 获取当前页面 菜单刷新后能自动选中
      let currentUrl = window.location.href;
      let currentPage = currentUrl.split("/")[3].replace("#", "");
      this.currentMenu = currentPage;
    },
    pathLight() {
      //创作中心中的页面
      var arr = [
        '/admin/competition-center/list',
        '/admin/competition-center/category',
        '/admin/competition-center/tag-manage'
      ];
      if (
        arr.indexOf(this.$route.path) >= 0
      ) {
        this.activeClass = "is-active";
      } else {
        this.activeClass = "";
      }
    },
    clssroomActive() {
      var arr = [
        '/admin/classroom/manage',
        '/admin/classroom/competition'
      ];
      if (
        arr.indexOf(this.$route.path) >= 0
      ) {
        this.classroomClass = "is-active";
      } else {
        this.classroomClass = "";
      }
    }
  },
  mounted() {
    this.pathLight();
    this.clssroomActive();
  },
  watch: {
    $route() {
      this.pathLight();
      this.clssroomActive();
    }
  }
};
</script>

<style scoped>
.admin_sidebar {
  /* height: 100%; */
  position: absolute;
  /* top: 60px; */
  /* min-height: 100%; */
}
.menu {
  width: 240px;
  height: 100%;
}
.admin_sidebar .is-active {
  background-color: #409eff;
  color: #ffffff;
}
.el-menu-item {
  text-align: center;
}
.active {
  background-color: #409eff;
  color: #ffffff;
}
</style>
